import { Injectable } from "@angular/core";
import { HOAApiBase } from "@app/services/apiServices/utils/HOAApiBase";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CalendarApi extends HOAApiBase {

    constructor() {
        super('CalendarApi')
    }

    /**
     * Retrieve holiday information
     * Retrieve a list of contact points for the application\n
     */
    public holidayCalendarGet(anonymous: boolean, calendarYear: number): Observable<string[]> {

        // validate parameters
        this.check({ anonymous }, 'boolean', b => typeof b === 'boolean')
        this.check({ calendarYear }, 'valid year', year => Number(year) > 0 && String(year).length === 4)

        const url = anonymous ?
            this.createUrl("HOAPass", `/holidays/${calendarYear}`) :
            this.createUrl("hoa-gateway", `/holidays/${calendarYear}`)

        return this.http.get<string[]>(url);
    }
}

